import * as React from "react";
import {
  ICourseComponentPart,
  IExerciseAnalyticsCommonProps,
  UnitChartType,
} from "../../../../../App/Analytics/Common";
import UnitInstanceAnalytics from "./UnitInstanceAnalytics";
import { QuestionsSectionTitle, TotalResponsesHeader, QuestionAnalyticsHeader } from "../UnitsAnalytics.styles";
import { AssessmentsIcon } from "../../AnalyticsIcons";

export interface IQuestionAnalyticsProps extends IExerciseAnalyticsCommonProps {
  questions: ICourseComponentPart[];
}

const QuestionsAnalytics: React.SFC<IQuestionAnalyticsProps> = ({
  fetchAnalytics,
  questions,
  users,
  selectedUsers,
  usersAnalytics,
  searchLocale,
  onSelectAssessmentName,
}) => {
  if (questions.length === 0) {
    return null;
  }
  return (
    <>
      <QuestionAnalyticsHeader data-testid="question-analytics-header">
        <QuestionsSectionTitle>
          <AssessmentsIcon />
          Assessment Questions
        </QuestionsSectionTitle>
        <TotalResponsesHeader>Total Responses</TotalResponsesHeader>
      </QuestionAnalyticsHeader>
      <UnitInstanceAnalytics
        courseData={questions}
        fetchAnalytics={fetchAnalytics}
        type={UnitChartType.Questions}
        onSelectAssessmentName={onSelectAssessmentName}
        searchLocale={searchLocale}
        selectedUsers={selectedUsers}
        users={users}
        usersAnalytics={usersAnalytics}
      />
    </>
  );
};

export default QuestionsAnalytics;
